export default "__VITE_ASSET__D_OA$C3C__"